import {
  typoNavigation,
  horizontalWrapperStyles,
} from 'components/Templates/styles/Red/commonObjectsStyles';


import cloneDeep from 'helpers/cloneDeep';

import buttonPrimary from 'components/Templates/styles/Red/buttons/buttonPrimary';
import buttonSecondary from 'components/Templates/styles/Red/buttons/buttonSecondary';

import burgerSvg from 'components/Templates/styles/Red/assets/SVG/icons_mobilemenu_white.svg';
import closeSvg from 'components/Templates/styles/Red/assets/SVG/icons_x_white.svg';


/* eslint-disable */
const thisStyle = {
  wrapper: {
    '0': {
      'position': 'sticky',
      'height': '10rem',
      'top': '0',
      'left': '0',
      'display': 'block',
      'width': '100%',
      'background-color': '{invertedBackgroundColor}',
      'z-index': '900',
      'padding-left': '3rem',
      'padding-top': '2rem',
      'padding-right': '20rem',
      'border-bottom': '1px solid #383838'
    },
    '37_5': {
      'height': '10rem',
      'padding-top': '2rem',
      'padding-bottom': '2rem',
      'padding-left': '2rem',
      'padding-right': '2rem'
    }
  },
  buttonWrapper: {
    '0': {
      'display': 'inline-block',
      'position': 'absolute',
      'right': '3rem',
      'top': '2.5rem'
    },
    '37_5': {
      'top': '2.5rem'
    }
  },
  horizontalWrapper: {
    '0': {
      ...horizontalWrapperStyles,
      'display': 'flex'
    },
  },
  horizontalWrapperMobile: {
    '0': {
      ...horizontalWrapperStyles,
      'display': 'block'
    },
  },
  logo: {
    '0': {
      'display': 'block',
      'position': 'relative',
      'width': '5.5rem',
      'height': '5.5rem',
      'margin-right': '6rem',
      'float': 'left',
      'background-size': 'contain',
      'background-repeat': 'no-repeat',
      'background-position-y': 'center',
    },
    '76_8': {
      'margin-right': '2rem',
    },
  },
  logoMobile: {
    '0': {
      'display': 'block',
      'position': 'relative',
      'width': '5.5rem',
      'height': '5.5rem',
      'margin-right': '0',
      'background-size': 'contain',
      'background-repeat': 'no-repeat',
      'background-position-y': 'center',
      'min-height': '5.5rem'
    },
  },
  burger: {
    '0': {
      'display': 'block',
      'margin-top': '1rem',
      'margin-bottom': '2rem',
      'color': 'white',
      'height': '3rem',
      'width': '3rem',
      'background-image': 'url('+burgerSvg+')',	
      'background-repeat': 'no-repeat',
      'cursor': 'pointer',
      'float': 'left',
      'margin-right': '1rem'
    },
  },
  navigationWrapper: {
    '0': {
      'height': '6rem',
      'display': 'inline-block'
    }
  },
  navigationWrapperVertical: {
    '0': {
      'height': 'auto',
      'display': 'flex',
      'flex-direction': 'column',
      'width': '100%',
      'background-color': '{invertedBackgroundColor}',
      'padding-left': '3rem',
      'top': '10rem',
      'position': 'absolute',
      'left': '0',
      'padding-top': '5rem',
      'padding-bottom': '3rem',
      'padding-right': '4rem',
      'height': 'calc(100vh - 10rem)',
      'bottom': '0',
      'overflow': 'auto',
      'z-index': '1'
    },

  },
  navigationWrapperVerticalHidden: {
    '0': {
      'display': 'none'
    }
  },
  navigationWrapperHidden: {
    '0': {
      'height': '0',
      'display': 'inline-block',
      'visibility': 'hidden',
      'overflow': 'hidden'
    },
  },
  linkNoLeftPadding: {
    '0': {
      ...typoNavigation,
      'text-decoration': 'none',
      'cursor': 'pointer',
      'margin-top': '1.5rem ',
      'margin-bottom': '2.5rem',
      'padding-top': '1rem',    
      'padding-bottom': '1rem',  
      'padding-right': '2rem',    
      'margin-left': '0',
      'float': 'left',
      'color': '{lightSecondaryTextColor}',
    }
  },
  linkNoLeftPadding_hover: {
    '0': {
      'text-decoration': 'underline' 
    }
  },
  link: {
    '0': {
      ...typoNavigation,

      'text-decoration': 'none',
      'cursor': 'pointer',
      'margin-top': '1.5rem ',
      'margin-bottom': '2.5rem',
      'padding-top': '1rem',    
      'padding-bottom': '1rem',  
      'padding-right': '2rem',    
      'padding-left': '2rem',    
      'margin-left': '0',
      'float': 'left',
      'color': '{lightSecondaryTextColor}'
    }
  },
  link_hover: {
    '0': {
      'color': '{lightTextColor}',
      'text-decoration': 'underline' 
    }
  },
  subLinksWrapper: {
    '0': {
      'position': 'absolute',
      'margin-top': '0',
      'margin-left': '0',
      'top': '6.5rem',
      'background-color': 'rgb(47 42 40)',
      'z-index': '200',
      'left': '-1rem'
    },
  },
  subLinksWrapperVertical: {
    '0': {
      'position': 'relative',
      'display': 'block',
      'padding-top': '2rem',
      'width': '100%'
    },
  },
  subLink: {
    '0': {
      ...typoNavigation,
      'text-decoration': 'none',
      'cursor': 'pointer',
      'display': 'inline-block',
      'position': 'relative',
      'width': '100%',
      'padding': '2rem',
      'color': '{lightTextColor}',
      'white-space': 'nowrap'
    }
  },
  subLink_hover: {
    '0': {
      'text-decoration': 'underline'
    },
    '37_5': {
      'text-decoration': 'underline'
    },
  },
  buttonPrimary: buttonPrimary.buttonPrimary,
  buttonSecondary: buttonSecondary.buttonSecondary,
  buttonPrimaryMobile: cloneDeep(buttonPrimary.buttonPrimary),
  buttonSecondaryMobile: cloneDeep(buttonSecondary.buttonSecondary)
};

thisStyle.burgerClose = {	
  '0': {	
    ...thisStyle.burger['0'],
    'background-image': 'url('+closeSvg+')',	
    'height': '2.5rem',	
    'width': '2.5rem',	
    'margin-top': '1.5rem',	
    'float': 'left',
    'margin-right': '1rem'
  },	
};



thisStyle.buttonPrimary['37_5'] = {
    ...thisStyle.buttonPrimary['37_5'],   
    'max-width': '13rem',
    'margin-top': '0',
    'margin-bottom': '1rem'
}

thisStyle.buttonSecondary['37_5'] = {
    ...thisStyle.buttonSecondary['37_5'],   
    'max-width': '13rem',  
    'margin-top': '0',
    'margin-bottom': '1rem',
    'display': 'none'
}
thisStyle.buttonPrimaryMobile['0'] = {
  ...thisStyle.buttonPrimaryMobile['0'],   
  'width': '100%',
  'max-width': '30rem'
}

thisStyle.buttonSecondaryMobile['0'] = {
  ...thisStyle.buttonSecondaryMobile['0'],
  'width': '100%',
  'max-width': '30rem',
  'margin-bottom': '2rem'
}
export default thisStyle;
